export default __webpack_public_path__ + "static/media/btn_song_play.870b5ca8.png";